import Icon from '../components/Icon.vue'

Icon.register({
  mountain: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M634.9 462.7L346.9 14.7C341 5.5 330.9 0 320 0S299 5.5 293.1 14.7L5.1 462.7A32-32 0 0 1 3.9 495.3 32-32 0 0 1 32 512H608C619.7 512 630.5 505.6 636.1 495.3A32-32 0 0 1 634.9 462.7zM320 91.2L405.4 224H320L256 288 217.9 249.9 320 91.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mountain.js
// module id = O2IC
// module chunks = 144